// @ngInject
function loadSpinnerService($rootScope) {
    return {
        start: start,
        stop: stop
    };

    function start(name, opt) {
        var options = opt || { message: '' };
        options.message = options.message || '';
        $rootScope.$applyAsync(function() {
            $rootScope.$emit(name + '-start', options);
        });
    }

    function stop(name, opt) {
        var options = opt || {};
        options.force = options.force || false;
        $rootScope.$applyAsync(function() {
            $rootScope.$emit(name + '-stop', options);
        });
    }
}

// @ngInject
function loadSpinner($rootScope,usSpinnerService) {
    return {
        templateUrl: 'directives/loadSpinner/loadSpinner.tpl.html',
        restrict: 'EA',
        replace: true,
        scope: {
            spinnerName: '@',
            spinnerMessage: '@'
        },
        link: function($scope) {
            var loaders = 0;

            $rootScope.$on($scope.spinnerName + '-start', function(event, data) {
                $scope.isLoading = true;
                $scope.spinnerMessage = data.message;
                usSpinnerService.spin($scope.spinnerName);
                loaders = loaders + 1;
            });

            $rootScope.$on($scope.spinnerName + '-stop', function(event, data) {
                loaders = loaders > 0 ? loaders - 1 : loaders;
                if (loaders === 0 || data.force === true) {
                    usSpinnerService.stop($scope.spinnerName);
                    $scope.isLoading = false;
                }
            });
        }
    };
}

angular
    .module('directives.loadSpinner', ['angularSpinner'])
    .service('loadSpinnerService', loadSpinnerService)
    .directive('loadSpinner', loadSpinner);
